<script setup lang="ts">
import { EColors } from '@/types/constants/ColorValues'

type Props = {
    title?: string
    type?: EColors
}
defineProps<Props>()
defineEmits<{ (e: 'close'): void }>()
</script>

<template>
    <b-message
        :title="title"
        :type="`is-${type ?? EColors.INFO}`"
        class="message-card"
        @close="$emit('close')"
        v-bind="$attrs">
        <slot />
    </b-message>
</template>

<style scoped lang="scss">
.message-card {
    &.message {
        &:not(:last-child) {
            margin-bottom: unset;
        }
        & .message-body {
            padding: 0.5em;
        }
    }
}
</style>
